import { Undo16 } from 'ui/icons';
import { ButtonProps } from 'modules/queryBuilder/contexts';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { QueryBuilderIconButton } from './QueryBuilderIconButton';

export const DATA_TEST = {
  button: 'undo-button',
};

export const UndoButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <QueryBuilderIconButton
      {...props}
      dataTest={DATA_TEST.button}
      tooltipContent={t('storybook.buttons.undo')}
      Icon={Undo16}
    />
  );
};
